import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);
import { OrderDataImpl } from "../cubiq-model-multi-asset/model/impl/OrderDataImpl";
import { LockType } from "../cubiq-model-multi-asset/model/enum/LockType";

const orderDataLock: RegExp = /logger=OrderDataLock/;
const disabled: boolean = orderDataLock.exec(window.location.hash) == null;

if (!disabled) {
  logger.out.info(`OrderDataLockLogger() enabled`);
}

export const OrderDataLockLogger = disabled
  ? function () {
      // no-op
    }
  : function OrderDataLockLogger(orderData: OrderDataImpl, callee: string = "unspecified"): void {
      if (orderData instanceof OrderDataImpl) {
        logger.out.info(
          `OrderDataLockLogger() ${
            orderData.orderId != null ? orderData.orderId.toString() : null
          }` +
            ` with LockType.${LockType[orderData.lockType]}` +
            ` locked to user id ${
              orderData.lockUserId != null ? orderData.lockUserId.toString() : orderData.lockUserId
            }` +
            ` locked to siLockUserId ${
              orderData.siLockUserId != null
                ? orderData.siLockUserId.toString()
                : orderData.siLockUserId
            }` +
            ` observed by callee:${callee}`,
        );
      }
    };
